import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

var md5 = require('md5');

const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//const customspremurl='https://customsprem.gov.tc/';
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});
const [modal, setModal] = useState({open:false});
const [wptapp, setWptapp] = useState({});


const [supnameopts, setSupnameopts] = useState([]);
const [origstate, setOrigstate] = useState({
OVR_RQS_DAT:""
, OVR_DCN:""
, COPIED:null
});


const [decisionopts, setDecisionopts] = useState([
<option key='dcnopy0' value='' ></option>
,<option key='dcnopy1' value='1' >Approve Request</option>
,<option key='dcnopy2' value='0' >Deny Request</option>
]);

const location = useLocation();


useEffect(() => {
document.title =   "APS Override";
//getmd5count
console.log("SUP_PVG: "+sessionStorage.getItem("SUP_PVG"));

if (location.state.WPT_APP_ID)
	getsupervnames();
else
	alert("error: no application id was received to process");

 },[]);



useEffect(() => {
	console.log("origstate: "+JSON.stringify(origstate));
	if (origstate.COPIED==false)
		getwptapp();
		
 },[origstate.COPIED]);


useEffect(() => {
	
	if (wptapp.REF_NUM && origstate.COPIED==false)
		setOrigstate((prev)=>{
			return {...prev, OVR_RQS_DAT:wptapp.OVR_RQS_DAT, OVR_DCN:wptapp.OVR_DCN, COPIED:true }
		});
 },[wptapp]);




async function getsupervnames(){

const WPT_APP_ID=location.state.WPT_APP_ID;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME")} )
  };		
	
	setWptapp({});
	
  fetch(resturl+'rarwpform/getsupervnames',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetsupervnames(res) )
      .catch(err => console.log(err));

}//end func

function aftergetsupervnames(res){

if (!res.length)
	return;

let temp=[];

res.map((col, index) => {
	
	const key="supervname_"+index;
	
	temp.push(<option key={key} value={col['USERNAME']}  >{col['FULLNAME']}</option>);

	});//end map

setSupnameopts(temp);
setOrigstate((prev)=>{
	return {...prev, COPIED:false }
});

}//end func



function handleChange(e){
	//OVR_RQS_SUP
	const {name, value} = e.target;
	
		setWptapp((prev)=>{
			return {...prev, [name]:value}
		});
	
	if (name=="OVR_DCN")
		document.getElementsByName("PWD")[0].focus();
	
}//end func


async function checkadupwd(){
	
if (wptapp.OVR_DCN==""){
	alert("select decision");
	return;
	}//end if

/*
const PWD=window.prompt("supervisor's password: ");
if (!PWD)Wavefont
	return;
*/
const PWD=document.getElementsByName("PWD")[0].value;

const params={
 	username: wptapp.OVR_RQS_SUP
	, pwd: md5(PWD)
};

setDowait({show:true});

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
 await fetch(customspremurl+'rarlogin/checkadupwd',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercheckadupwd(res) )
      .catch(err => console.log(err));	

}//end func

function aftercheckadupwd(res){
	
setDowait({show:false});	

//document.getElementsByName("PWD")[0].type="text";
document.getElementsByName("PWD")[0].value="";
	
let EMAIL_COUNT=0, AUTH_COUNT=0, AD_USER="";

if (res.length)
	if (res.length==1){
		EMAIL_COUNT=res[0].EMAIL_COUNT;
		AUTH_COUNT=res[0].AUTH_COUNT;
		AD_USER=res[0].AD_USERNAME;
		//change username to email address if login via ad user
		//username=res[0].GOV_TC_EMAIL?res[0].GOV_TC_EMAIL:cred.username;
		}//end if
		
if (AUTH_COUNT==1)
	wptovrddcsn();
else
	showsnackbar("authentication failed");

}//end func



async function resetovrrqs(e){

e.preventDefault();

const confirmed=window.confirm("override request will be deleted.  Ok?");

const params={
	WPT_APP_ID:location.state.WPT_APP_ID
, USERNAME:sessionStorage.getItem("USERNAME")
, OVR_RQS_DAT:wptapp.OVR_RQS_DAT
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarwpform/resetovrrqs',requestOptions)
      .then(res => res.json())
      .then(res => 	afterresetovrrqs(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterresetovrrqs(res){
	setDowait({show:false});
	
const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;	

if (UPDATE_COUNT==0)
	showsnackbar("the update may have failed");
else{
	showsnackbar("please refresh the page in browser");
	const data=res[0];
	setOrigstate((prev)=>{
		return {...prev
		  ,OVR_RQS_DAT: data.OVR_RQS_DAT??""
		  ,OVR_RQS_USR: data.OVR_RQS_USR??""
		  ,OVR_RQS_SUP: data.OVR_RQS_SUP??""
		  ,OVR_DCN: data.OVR_DCN??""
		  ,OVR_DCN_DAT: data.OVR_DCN_DAT??""
		  ,OVR_DCN_SUP: data.OVR_DCN_SUP??""
		  }
		});
	}
	

}//end func	
async function wptovrddcsn(){

const params={
	WPT_APP_ID:location.state.WPT_APP_ID
, OVR_DCN_SUP:sessionStorage.getItem("USERNAME")
, OVR_DCN:wptapp.OVR_DCN
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});
	
 await fetch(resturl+'rarwpform/wptovrddcsn',requestOptions)
      .then(res => res.json())
      .then(res => 	afterwptovrddcsn(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterwptovrddcsn(res){
	console.log("afterwptovrddcsn: "+JSON.stringify(res));
	
	setDowait({show:false});
	
	let UPDATE_COUNT=0;
	if (res.length)
		if (res.length==1)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	if (UPDATE_COUNT==1){
		showsnackbar("done!");
		setOrigstate((prev)=>{
			return {...prev, COPIED:false }
		});
		}//end if
	else
		showsnackbar("that failed! please try again or contact admin");
	
}//end func


function navigtowptform(){
	//ALD01qg
navigate("/wptform",{state:{WPT_APP_ID:location.state.WPT_APP_ID}});
}//end func

async function getmd5count(){

if (wptapp.OVR_RQS_SUP==""){
	alert("select supervisor");
	return;
	}//end if

const params={
 username:wptapp.OVR_RQS_SUP

};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});	
	
  await fetch(customspremurl+'rarauthadng/getmd5count',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetmd5count(res) )
      .catch(err => console.log(err));

}//end func

function aftergetmd5count(res){
	
console.log("aftergetmd5count: "+JSON.stringify(res));
	
let MD5_COUNT=0;
if (res.length)
	if (res.length==1)
		MD5_COUNT=res[0].MD5_COUNT;

if (MD5_COUNT==0)
	alert("the supervisor must first login at http://borderforceapps.tcig.tc for authentication to work");
else
	wptovrdreqs();
		
}//end func


async function wptovrdreqs(){

if (wptapp.OVR_RQS_SUP==""){
	alert("select supervisor");
	return;
	}//end if

const params={
	WPT_APP_ID:location.state.WPT_APP_ID
, USERNAME:sessionStorage.getItem("USERNAME")
, OVR_RQS_SUP:wptapp.OVR_RQS_SUP
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	
	setDowait({show:true});	
  await fetch(resturl+'rarwpform/wptovrdreqs',requestOptions)
      .then(res => res.json())
      .then(res => 	afterwptovrdreqs(res) )
      .catch(err => console.log(err));

}//end func

function afterwptovrdreqs(res){
	setDowait({show:false});
	let UPDATE_COUNT=0;
	if (res.length)
		if (res.length==1)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	if (UPDATE_COUNT==1){
		showsnackbar("done!");
		setOrigstate((prev)=>{
			return {...prev, COPIED:false }
		});
		
		}//end if
	else
		showsnackbar("that failed! please try again or contact admin");

}//end func

async function getwptapp(){

const WPT_APP_ID=location.state.WPT_APP_ID;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		
	
	setWptapp({});
	
 await fetch(resturl+'rarwpform/getwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptapp(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwptapp(res){
	
let datas=wptapp;
console.log("REF_NUM: "+res[0].REF_NUM);
//datas['REF_NUM']=res[0].REF_NUM;

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
	setWptapp(datas);

updatecwnextwptappid(datas.CASE_WORKER);
/*
setWptapp((prev)=>{
	return {...prev, datas}
});
*/
	
	

}//end func


async function updatecwnextwptappid(CASE_WORKER){

const WPT_APP_ID=location.state.WPT_APP_ID;

const params={
	WPT_APP_ID: WPT_APP_ID
	, USERNAME: sessionStorage.getItem("USERNAME")
	, CASE_WORKER: CASE_WORKER
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	

 await fetch(resturl+'rarwpform/updatecwnextwptappid',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatecwnextwptappid(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatecwnextwptappid(res){
	
}//end func

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func



async function openScans (e) {
e.preventDefault();


const params={

	};
	
console.log("openScans "+JSON.stringify( params ) )	;
	
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };


		setDlwait({show:true});
	
  await fetch(resturl+'rarscans/getwebuserfile',requestOptions)
      .then(res => afteropenScans(res))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res){
const filename="reginfo.pdf";
//const downloadFilename = wptapp.REF_NUM+"_"+filename;
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", filename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	

setDlwait({show:false});


}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



async function submitform1(e){
	
	e.preventDefault();
	
	const form1=document.getElementById("form1");
	// This is the important part, test if form is valid
	if (form1.checkValidity() === false){
		// This is the magic function that displays the validation errors to the user
		form1.reportValidity();   
		return; 
		}//end if
	
	if (wptapp.OVR_RQS_DAT=="")
		getmd5count();
	else
		checkadupwd();
	
}//end func


	
let button1=<></>;
let tr_decisionopts=<></>;
let tr_supnameopts=<></>;
let tr_navigtowptform=<></>;


if (origstate.OVR_RQS_DAT===""){
	button1=!dowait.show && <button className="button" id='btnupdate'  >submit over-ride request</button>;
	tr_supnameopts=<tr key="tr_OVR_RQS_SUP" >
			<td align='right' >Supervisor: </td>
			<td align='left' >
				<select name="OVR_RQS_SUP" required value={wptapp.OVR_RQS_SUP} onChange={(e)=>{handleChange(e);}} >
				<option value="" ></option>
				{supnameopts}
				</select>
			</td>
			</tr>;

	}//end if
else if (origstate.OVR_DCN===""){
	button1=!dowait.show && <button className="button" id='btnupdate' >submit over-ride decision</button>;
	
	tr_supnameopts=<tr key="tr_OVR_RQS_SUP" >
			<td align='right' >Supervisor: </td>
			<td align='left' >
				<input name="" value={wptapp.OVR_RQS_SUP} className="gnsbro" readOnly />
				&nbsp;&nbsp;<a href="#" onClick={(e)=>{resetovrrqs(e);}} className="nodecor" ><img src="img/nok.gif" border="0" /> undo this action</a>
			</td>
			</tr>;
			tr_decisionopts=<>
			<tr key="tr_OVR_DCN" >
			<td align='right' >Decision: </td>
			<td align='left' >
				<select name="OVR_DCN" required onChange={(e)=>{handleChange(e);}} >
				{decisionopts}
				</select>
			</td>
			</tr>
			<tr>
			<td align='right' >Supervisor's Password: </td>
			<td align='left' >
				<input name="PWD" type="password" required autoComplete="off" onPaste={(e) => {e.preventDefault();}} onFocus={(e)=>{e.target.select();}} />
									
			</td>
			</tr>
			</>;
			//autocomplete="new-password"class="noto-sans-kr-400"
	}//end else if
else{
	tr_supnameopts=<tr key="tr_OVR_RQS_SUP" >
			<td align='right' >Supervisor: </td>
			<td align='left' ><input name="" value={wptapp.OVR_RQS_SUP} className="gnsbro" readOnly /></td>
			</tr>;
	tr_decisionopts=<tr key="tr_OVR_DCN" >
			<td align='right' >Decision: </td>
			<td align='left' ><input name="" value={wptapp.OVR_DCN} className="gnsbro" readOnly /></td>
			</tr>;

	if (wptapp.OVR_DCN==1)
		tr_navigtowptform=<tr key="tr_NAV_LNK" >
			<td align='right' ></td>
			<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{ e.preventDefault(); navigtowptform(); } } ><img src="img/folderyel.png" border="0"  height='18' />&nbsp;open application {wptapp.REF_NUM}</a></td>
			</tr>;
			
	}//end else
	
  return (
    <>
	
	{/*
	<div align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
search criteria:
&nbsp;<input name='txt' value={crit.txt} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='search by name' />
&nbsp;&nbsp;<input type="checkbox" id="cbverified" name="verified" defaultValue={crit.verified} onClick={(e)=>{handleChange(e);}} />
<label htmlFor="cbverified" className="hand" >show verified & refused users</label>
</div>
	*/}
	
		

		<p align="center" style={{marginBottom:"0px",fontSize:"20px"}}>Work Permit Application {wptapp.REF_NUM} with Id {wptapp.WPT_APP_ID}</p>
		<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Override First Come First Serve</p>
			
			<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
			<table align='center'>
			<tbody>

			<tr  key="tr_SUBMITTED_TO_CSC" >
			<td align='right' >Date Submitted: </td>
			<td align='left' >{wptapp.CHR_SUBMITTED_TO_CSC}</td>
			</tr>
			<tr  key="tr_APP_TYPE" >
			<td align='right' >Application Type: </td>
			<td align='left' >{wptapp.APP_TYPE}</td>
			</tr>
			<tr  key="tr_AGENCY" >
			<td align='right' >Agency: </td>
			<td align='left' >{wptapp.AGENCY}</td>
			</tr>
			<tr  key="tr_MPR_NAME" >
			<td align='right' >Employer: </td>
			<td align='left' >{wptapp.MPR_NAME}</td>
			</tr>
			<tr key="tr_MPE_FIRST_NAME" >
			<td align='right' >Employee: </td>
			<td align='left' >{wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}</td>
			</tr>
			<tr key="tr_IMG_REF_NO" >
			<td align='right' >Immigration Ref #: </td>
			<td align='left' >{wptapp.IMG_REF}</td>
			</tr>
			<tr  key="tr_MPE_CTRY" >
			<td align='right' >Country of Birth: </td>
			<td align='left' >{wptapp.MPE_BIRTH_COUNTRY}</td>
			</tr>
			<tr  key="tr_MPE_DOB" >
			<td align='right' >Date of Birth: </td>
			<td align='left' >{wptapp.CHR_MPE_DOB}</td>
			</tr>
			<tr key="tr_OCCUPATION" >
			<td align='right' >Job Title: </td>
			<td align='left' >{wptapp.MPE_OCCUPATION}</td>
			</tr>
			<tr key="tr_WAGES" >
			<td align='right' >Salary: </td>
			<td align='left' >{"$ "+wptapp.MPE_SALARY_AMT+" "+wptapp.MPE_SALARY_PRD}</td>
			</tr>
			<tr key="tr_WRK_CONTRACT" >
			<td align='right' >Contract Dates: </td>
			<td align='left' >{wptapp.CHR_WRK_CONTRACT_START+" to "+wptapp.CHR_WRK_CONTRACT_END}</td>
			</tr>
			{tr_supnameopts}
			{tr_decisionopts}
			{tr_navigtowptform}


			<tr>
			<td align='right' >
				<a href="#" title="return to list" onClick={(e)=>{ e.preventDefault(); navigate("/wpapps"); }} ><img src="img/return.png" /></a>
				&nbsp;
			</td>
			<td align='left' >
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{button1}
			</td>
			</tr>		
			</tbody>
			</table>
			</form>

<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;